export const BACKEND_URL = "https://task-2-vgu2.onrender.com";